<template>
    <el-dialog :title="title"
        :visible="showDialog"
        @open="create"
        @close="close"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
        <div class="row">
            <div class="col-12">
                <el-tabs>
                  <el-tab-pane label="Datos de Usuario">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group"
                                :class="{'has-danger': errors.name}"
                            >
                                <label class="control-label">
                                    Nombre
                                </label>
                                <el-input v-model="form.name"
                                    placeholder="Ingresar nombre"></el-input>
                                <small v-if="errors.name"
                                    class="form-control-feedback"
                                    v-text="errors.name[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group"
                                :class="{'has-danger': errors.email}"
                            >
                                <label class="control-label">
                                    Correo electrónico
                                </label>
                                <el-input v-model="form.email"
                                    placeholder="Ingresar correo electrónico"></el-input>
                                <small v-if="errors.email"
                                    class="form-control-feedback"
                                    v-text="errors.email[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group"
                                :class="{'has-danger': errors.password}"
                            >
                                <label class="control-label">
                                    Contraseña
                                </label>
                                <el-input v-model="form.password"
                                    placeholder="Ingresar contraseña"
                                    show-password
                                    type="password"
                                ></el-input>
                                <small v-if="errors.password"
                                    class="form-control-feedback"
                                    v-text="errors.password[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group"
                                :class="{'has-danger': error_password_confirmation}"
                            >
                                <label class="control-label">
                                    Confirmar Contraseña
                                </label>
                                <el-input v-model="form.password_confirmation"
                                    placeholder="Confirmar contraseña"
                                    show-password
                                    type="password"
                                    @input="verifyPassword"
                                ></el-input>
                                <small v-if="error_password_confirmation"
                                    class="form-control-feedback"
                                >
                                    Las contraseñas no coinciden
                                </small>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group"
                                :class="{'has-danger': errors.role_id}"
                            >
                                <label class="control-label">
                                    Perfil
                                </label>
                                <el-select v-model="form.role_id"
                                    placeholder="Seleccionar perfil"
                                >
                                    <el-option v-for="(role, index) in roles"
                                        :key="index"
                                        :label="role.name"
                                        :value="role.id"
                                    ></el-option>
                                </el-select>
                                <small v-if="errors.role_id"
                                    class="form-control-feedback"
                                    v-text="errors.role_id[0]"></small>
                            </div>
                        </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="Permisos">
                    <div class="row">
                        <div class="col-12">
                            <span>Permisos Módulos</span>
                        </div>
                        <div class="col-12">
                            <div class="form-group tree-container-admin">
                                <el-tree
                                    ref="tree"
                                    :data="modules"
                                    node-key="id"
                                    show-checkbox
                                    :props="{ label: 'label' }"
                                    :expand-on-click-node="false"
                                    default-expand-all
                                />
                            </div>
                        </div>
                        <div class="col-12 mt-4">
                            <span>Sistemas de Clientes</span>
                        </div>
                        <div class="col-12 col-md-4">
                            <el-checkbox label="Agregar"
                                v-model="form.add_clients_system"
                            ></el-checkbox>
                        </div>
                        <div class="col-12 col-md-4">
                            <el-checkbox label="Eliminar"
                                v-model="form.delete_clients_system"
                            ></el-checkbox>
                        </div>
                        <div class="col-12 col-md-4">
                            <el-checkbox label="Actualizar"
                                v-model="form.update_clients_system"
                            ></el-checkbox>
                        </div>
                        <div class="col-12 mt-2">
                            <span>Otros Permisos</span>
                        </div>
                        <div class="col-12">
                            <el-checkbox label="Exportar excel de sistemas de clientes"
                                v-model="form.export_excel_clients_system"
                            ></el-checkbox>
                        </div>
                        <div class="col-12">
                            <el-checkbox label="Bloquear/Desbloquear masivamente sistemas de clientes"
                                v-model="form.lock_unlock_clients_system"
                            ></el-checkbox>
                        </div>
                        <div class="col-12">
                            <el-checkbox label="Editar el Inicio de Ciclo de limites"
                                v-model="form.edit_billing_cycle"
                            ></el-checkbox>
                        </div>
                        <div class="col-12">
                            <el-checkbox label="Editar el Inicio de Ciclo de Pago"
                                v-model="form.edit_payment_cycle"
                            ></el-checkbox>
                        </div>
                        <div class="col-12">
                            <el-checkbox label="Editar límites de sistemas de clientes"
                                v-model="form.edit_limit_client"
                            ></el-checkbox>
                        </div>
                        <div class="col-12">
                            <el-checkbox label="Editar precio de sistemas de clientes"
                                v-model="form.edit_payment_client_plan"
                            ></el-checkbox>
                        </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="Datos personales">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group"
                                :class="{ 'has-danger' : errors.identity_document_type }"
                            >
                                <label class="control-label">
                                    Tipo Doc. Identidad
                                </label>
                                <el-select v-model="form.identity_document_type" placeholder="Seleccionar tipo de documento">
                                    <el-option v-for="(item, index) in identity_document_types"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                                <small v-if="errors.identity_document_type"
                                    class="form-control-feedback"
                                    v-text="errors.identity_document_type[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Número
                                </label>
                                <el-input v-model="form.number"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Nombres
                                </label>
                                <el-input v-model="form.first_name"
                                    placeholder="Ingresar nombres"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Apellidos
                                </label>
                                <el-input v-model="form.last_name"
                                    placeholder="Ingresar apellidos"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Fecha de Nacimiento
                                </label>
                                <el-date-picker
                                    v-model="form.birthdate"
                                    type="date"
                                    placeholder="Seleccionar fecha"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Correo electrónico personal
                                </label>
                                <el-input v-model="form.email_personal"
                                    placeholder="Ingresar correo electrónico personal"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    N° Celular personal
                                </label>
                                <el-input v-model="form.phone_personal"
                                    placeholder="Ingresar número de celular personal"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Dirección
                                </label>
                                <el-input v-model="form.address"
                                    placeholder="Ingresar dirección"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Correo electrónico corporativo
                                </label>
                                <el-input v-model="form.email_corporate"
                                    placeholder="Ingresar correo electrónico corporativo"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Fecha de Contratación
                                </label>
                                <el-date-picker
                                    v-model="form.date_contract"
                                    type="date"
                                    placeholder="Seleccionar fecha"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    N° Celular corporativo
                                </label>
                                <el-input v-model="form.phone_corporate"
                                    placeholder="Ingresar número de celular corporativo"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Cargo
                                </label>
                                <el-input v-model="form.position"
                                    placeholder="Ingresar cargo"></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Foto
                                </label>
                                <el-upload
                                    action="/users/uploads"
                                    :headers="headers"
                                    :on-success="onSuccess"
                                    :show-file-list="false"
                                    :before-upload="beforeUpload"
                                    class="avatar-uploader"
                                >
                                    <img v-if="form.photo_url"
                                         :src="form.photo_url"
                                         class="avatar">
                                    <i v-else
                                       class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
            </div>
            <div class="col-12 mt-3 text-right">
                <el-button @click="close">Cancelar</el-button>
                <el-button type="primary"
                    @click.prevent="submit"
                    :loading="loading"
                >
                    {{ userId ? 'Actualizar' : 'Guardar' }}
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: ['showDialog', 'userId'],
        data() {
            return {
                title: null,
                form: {},
                errors: {},
                identity_document_types: [
                    {
                        id: '0',
                        name: 'Doc.trib.no.dom.sin.ruc'
                    },
                    {
                        id: '1',
                        name: 'DNI'
                    },
                    {
                        id: '4',
                        name: 'CE'
                    },
                    {
                        id: '6',
                        name: 'RUC'
                    },
                    {
                        id: '7',
                        name: 'Pasaporte'
                    }
                ],
                roles: [],
                modules: [],
                treeProps: { label: 'label', children: 'children', disabled: 'disabled' },
                loading: false,
                error_password_confirmation: false,
                headers: headers_token,
                errors: {}
            }
        },
        async created() {
            await this.getDataForm()
        },
        methods: {
            async create() {
                this.initForm()
                this.title = this.userId ? 'Editar Usuario' : 'Nuevo Usuario';
                if (this.userId) {
                    await this.getUserData()
                }
            },
            
            async getDataForm() {
                try {
                    const response = await this.$http.get(`/users/form_table`)
                    this.roles = response.data.roles
                    this.modules = response.data.modules_master.map(module => {
                        return {
                            id: module.id,
                            label: module.description,
                        }
                    })
                } catch (error) {
                    
                }
            },

            async getUserData() {
                try {
                    const response = await this.$http.get(`/users/record_by_id/${this.userId}`)
                    if (this.$refs.tree && response.data.modules_master) {
                        this.$refs.tree.setCheckedKeys(response.data.modules_master)
                    }
                    this.form = {
                        ...this.form,
                        ...response.data.user
                    }
                } catch (error) {
                    let message = error.response.data.message || 'Ocurrio un error inesperado'
                    this.$message.error(message)
                }
            },

            initForm() {
                this.form = {
                    // datos usuario
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    role_id: null,

                    // permisos
                    modules: [],
                    add_clients_system: false,
                    delete_clients_system: false,
                    update_clients_system: false,
                    export_excel_clients_system: false,
                    lock_unlock_clients_system: false,
                    edit_billing_cycle: false,
                    edit_payment_cycle: false,
                    edit_limit_client: false,
                    edit_payment_client_plan: false,

                    // datos personales
                    identity_document_type: null,
                    number: null,
                    first_name: null,
                    last_name: null,
                    birthdate: null,
                    email_personal: null,
                    phone_personal: null,
                    address: null,
                    email_corporate: null,
                    date_contract: null,
                    phone_corporate: null,
                    position: null,
                    photo_name: null,
                    photo_url: null,
                    photo_file: null,
                }
                this.errors = {}
            },

            async submit() {
                try {
                    this.loading = true
                    if (this.$refs.tree) {
                        const checked = this.$refs.tree.getCheckedKeys()
                        this.form.modules = checked
                    }
                    if (!this.form.modules.length) {
                        this.$message.error('Seleccione al menos un módulo')
                        return
                    }
                    if (this.userId) {
                        await this.update()
                    } else {
                        await this.save()
                    }
                } catch (error) {
                    console.error(error)
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                } finally {
                    this.loading = false
                }
            },

            async save() {
                const response = await this.$http.post(`/users/save`, this.form)
                if (response.data.success) {
                    this.$message.success(response.data.message)
                    this.close()
                    this.$eventHub.$emit('reloadData')
                } else {
                    this.errors = response.data.errors
                }
            },

            async update () {
                const response = await this.$http.post(`/users/update/${this.userId}`, this.form)
                if (response.data.success) {
                    this.$message.success(response.data.message)
                    this.close()
                    this.$eventHub.$emit('reloadData')
                } else {
                    this.errors = response.data.errors
                }
            },

            close() {
                this.$emit('update:showDialog', false)
                this.initForm()
                if (this.$refs.tree) {
                    this.$refs.tree.setCheckedKeys([])
                    this.$refs.tree.setCurrentKey(null)
                }
            },

            onSuccess(response, file, fileList) {
                if (response.success) {
                    this.form.photo_name = response.data.filename
                    this.form.photo_url = response.data.temp_image
                    this.form.photo_file = response.data.temp_path
                }
            },

            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error('La imagen no debe pesar mas de 2MB')
                }
                return isLt2M
            },

            verifyPassword() {
                this.error_password_confirmation = false
                if (this.form.password !== this.form.password_confirmation) {
                    this.error_password_confirmation = true
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/users/form-users.vue